<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BBS_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ bbsName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ noticeTitle }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_ITEM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ bbsCategoryItemNm }}
            </div>
          </div>
          <div class="col-xs-1" />
          <div class="col-xs-5" />
        </div>
      </div>
      <div class="mrB10" />
      <sui-web-editor
        ref="myEditor"
        :isViewer="true"
        class="width100"
        @loaded="retrieveDetails"
      />
      <div class="mrB10" />
      <cmp-file-attacher
        ref="fileAttacher"
        :pageId="this.$options.name"
        :showAddDeleteBtn="false"
        :showUpDownArrowBtn="false"
        :showDDRegion="false"
        :attachGroupId="'ATG_CLB_BBS_COMMON'"
        :attachDocumentId="attachDocumentId"
        :customAttachRestrictionSize="attachRestrictSize"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:delete="contextPageId"
          type="button"
          class="comm_btn_border"
          @click="deletion"
        >
          {{ $t('MSG_BTN_DEL') }}
        </sui-button>
        <sui-button
          v-if="isSameAuthorOrBBSADMIN(postUserId)"
          v-permission:update="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="modification"
        >
          {{ $t('MSG_BTN_MDFC') }}
        </sui-button>
        <sui-button
          v-permission:create="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onScrapClick"
        >
          {{ $t("MSG_BTN_SCRAP") }}
        </sui-button>
        <sui-button
          v-permission:print="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onPrintClick"
        >
          {{ $t("MSG_BTN_PRTG") }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00016', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
    },
    pageInitialData: {
      type: Object,
    },
  },
  data() {
    return {
      isWebEdtrInitialized: false,
      attachDocumentId: '',
      bbsName: 'FAQ',
      noticeTitle: '',
      faqDetail: [],
      viewerContents: 'post',
      bbsCatgGrpItemName: '',
      bbsCategoryItemNm: '',
      bbsIdValue: '',
      registeredUserName: '',
      viewer: 'data',
      bbsId: '',
      postIdParam: '',
      bbsTypeCode: '',
      isBBSAdmin: false,
      attachRestrictSize: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  beforeMount() {
    this.getSession();
    this.getBBName();
  },
  mounted() {
    this.retrieveDetails();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getBBName() {
      this.bbsName = this.pageInitialData.bbsName;
      this.bbsId = this.pageInitialData.bbsId;
      this.postIdParam = this.pageInitialData.postIdParam;
      this.bbsTypeCode = this.pageInitialData.bbsTypeCode;
      this.postUserId = this.pageInitialData.postUserId;
      this.attachRestrictSize = this.pageInitialData.attachRestrictSize;
      this.tbabRestrictSize = this.pageInitialData.tbabRestrictSize;
    },
    retrieveDetails() {
      const pathParam = {
        'post-id': this.pageInitialData.postIdParam,
      };
      http.request('PGE_CLB_00016', 'DTS_CLB_00010', {
        path: pathParam,
      }).then(res => {
        this.faqDetail = res.data;
        this.noticeTitle = res.data[0].noticobjTitle;
        this.viewerContents = res.data[0].noticObjContent;
        this.$refs.myEditor.setHtml(this.viewerContents);
        this.bbsCatgGrpItemName = res.data[0].bbsCategoryItemNm;
        this.bbsCategoryItemNm = res.data[0].bbsCategoryItemNm;
        this.registeredUserName = res.data[0].registrantName;
        if (res.data[0].attachFileList && res.data[0].attachFileList.length > 0) {
          /* Fetching the file list with static Document id */
          this.attachDocumentId = res.data[0].attachFileList[0].attachDocumentId;
        }
      }).catch(err => {
        console.log(err);
      });
      this.updateLogs(this.pageInitialData.postIdParam, 'R');
    },
    onCancel() {
      this.closePagePopup(false);
    },
    onClose() {
      this.closePagePopup(true);
    },
    updateLogs(postId, type) {
      const pathParam = {
        'post-id': postId,
      };
      http.request('PGE_CLB_00016', 'DTS_CLB_00061', {
        path: pathParam,
        data: {
          firstRegistrationProgramId: 'PGE_CLB_00016',
          bbsLogTypeCd: type,
          bbsId: this.bbsId,
          bbsLogDeptId: this.$store.getters.userInfo.departmentId,
          firstRegistrationUserId: this.$store.getters.userInfo.epid,
        },
      }).then(() => {});
    },
    modification() {
      utils.openLayerPopup('PGE_CLB_00018', this.onPagePopupCallback,
        {
          pageInitialData:
          {
            retrieveData: this.faqDetail,
            bbsName: this.pageInitialData.bbsName,
            bbsId: this.pageInitialData.bbsId,
            postIdParam: this.pageInitialData.postIdParam,
            attachRestrictSize: this.pageInitialData.attachRestrictSize,
            tbabRestrictSize: this.pageInitialData.tbabRestrictSize,
          },
          size: 'xlg',
        });
      this.onCancel();
    },
    deletion() {
      utils.messageBox('confirm', this.$t('MSG_ALT_DEL'), null, this.submitDeleteApi);
    },
    submitDeleteApi() {
      const pathParam = {
        'post-id': this.pageInitialData.postIdParam,
      };
      http.request('PGE_CLB_00016', 'DTS_CLB_00013', {
        path: pathParam,
        query: {
          bbsId: this.bbsId,
        },
      }).then(res => {
        if (res.data.resultCode) {
          utils.messageBox('information', this.$t('MSG_ALT_PRGS_OK'), null);
          this.onClose();
        }
      });
      this.updateLogs(this.pageInitialData.postIdParam , 'D');
    },
    // TODO : check the validation for Approval status when MY POST SCREEN is implemented.
    getSession() {
      this.sessionInfo = this.$store.getters.userInfo;
      const roleListArray = this.sessionInfo.roleList;
      const ifRoleExist = roleListArray.some(el => el.roleNickName === 'BBS_ADMIN');
      if (ifRoleExist) {
        this.isBBSAdmin = true;
      }
    },
    onPagePopupCallback(value) {
      if (value) {
        this.onClose();
      }
    },
    onPrintClick() {
      this.openPrintWindow('PGE_CLB_00031', 'bbsId', this.bbsId);
    },
    openPrintWindow(pageId, key, value) {
      const queryString = `?${key}=${value}&postIdParam=${this.postIdParam}&bbsName=${this.bbsName}&bbsTypeCode=${this.bbsTypeCode}`;

      utils.openWindowPopup(pageId, queryString, null, {
        top: 100, left: 300, height: 700, width: 915,
      });
    },
    onScrapClick() {
      const dataParams = {
        postUID: this.postIdParam,
        bbsId: this.bbsId,
        bbsTypeCode: this.bbsTypeCode,
        usrId: this.$store.getters.userInfo.userId,
      };

      utils.messageBox('confirm', this.$t('MSG_ALT_SCRAP'), null, () => {
        http.request(this.contextPageId, 'DTS_CLB_00065', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_SCRAP'));
        });
      });
    },
    isSameAuthorOrBBSADMIN(userId) {
      return this.isBBSAdmin || this.$store.getters.userInfo.userId === userId;
    },
  },
};
</script>
<style scoped>
</style>